import React, { useContext, useMemo } from "react";

import { IndexTable, Text } from "@shopify/polaris";
import { dateOptions, HomePageDateRangeWrapper } from "@vendor-app/app/AdminRoute/AdminHomeRoute/constants";
import {
  HomePageTableTab,
  getTomorrowTimestampRange,
  getOneWeekTimestampRange,
} from "@vendor-app/app/AdminRoute/AdminHomeRoute/utils";

import { HomeTableCells } from "../../Cells";
import { HomeTableAccess } from "../store";

import { ParsedTableDataContext } from "../context/parsedDataContext";

interface TableFilteringRangeProps {
  selectedTab: HomePageTableTab;
}

export const TableFilteringRange = ({ selectedTab }: TableFilteringRangeProps): JSX.Element => {
  const { todayTimestamp, tomorrowTimestamp } = getTomorrowTimestampRange();
  const { startTimestamp, endTimeStamp } = getOneWeekTimestampRange();

  let startDate, endDate;
  const format = (date: Date) => date.toLocaleDateString("en-US", dateOptions);
  if (selectedTab === HomePageTableTab.CANCELLED) {
    // endTimeStamp is new Date() - 7.
    startDate = endTimeStamp;
    endDate = startTimestamp;
  } else {
    startDate = todayTimestamp;
    endDate = tomorrowTimestamp;
  }
  return (
    <HomePageDateRangeWrapper>
      <Text as="span" variant="bodyMd" color="subdued">
        {format(new Date(startDate))} - {format(new Date(endDate))}
      </Text>
    </HomePageDateRangeWrapper>
  );
};

interface TableRowProps {
  row: HomeTableCells.RowDataType;
  position: number;
}

const TableRow = ({ row, position }: TableRowProps) => {
  const enabledColumns = HomeTableAccess.useEnabledColumns();

  const isSelected = HomeTableAccess.useIsSelected(row.id);
  const cells = useMemo(() => {
    return enabledColumns.map(c => HomeTableCells.Cells[c]);
  }, [enabledColumns]);

  return (
    <IndexTable.Row id={row.id} position={position} selected={isSelected}>
      {cells.map((Cell, key) => {
        return <Cell key={key} row={row} />;
      })}
    </IndexTable.Row>
  );
};

export const TableRows = () => {
  const data = useContext(ParsedTableDataContext);

  return (
    <React.Fragment>
      {data.map((sub, key) => (
        <TableRow key={key} row={sub} position={key} />
      ))}
    </React.Fragment>
  );
};
